import { useQuery } from "@tanstack/react-query";
import { getProjectData } from "../api";
import { reactQueryCacheAndRefetchOptions } from "@";
import { projectsKeys } from "./keys";
import type { Bank, Category, GiftProject } from "../../types";

interface ProjectDataResult {
  banks: { data: Bank[] };
  categories: Category[];
  giftProjects: GiftProject[];
}

// Query hook for fetching project data (banks, categories, giftProjects)
export const useProjectDataQuery = () => {
  return useQuery<ProjectDataResult>({
    queryKey: projectsKeys.projectData(),
    queryFn: async () => {
      const [banksRes, categoriesRes, giftProjectsRes] = await getProjectData();
      return {
        banks: banksRes.data,
        categories: categoriesRes.data,
        giftProjects: giftProjectsRes.data,
      };
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};
